import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import banks from '../global/banks';

export default ({onChange, name, value, error, helperText, ...props}) => {

    const options = banks?.map(item => ({label: item.name, id: item.id})) || [];

    const handleChange = (e, data) => {
        console.log(data.id)
        onChange(name, data?.id || '');
    };

    const selectBank = options.filter(item => value === item.id )[0];

    return (
        <>
            <Autocomplete
                options={options}
                onChange={handleChange}
                value={selectBank || null}
                isOptionEqualToValue={(option, value)=> (option.id==value.id) }
                id="select-bank"
                fullWidth
                renderInput={params => <TextField {...params} error={error} helperText={helperText} label="Selecione o banco" />}
            />
        </>
    );
};
